export default __webpack_public_path__ + "static/media/G0160-Newborn_Life_Support_algorithm.1711619160000.1476b1c3.jpg";